import { render, staticRenderFns } from "./ActivityBuilder.vue?vue&type=template&id=564af68d"
import script from "./ActivityBuilder.vue?vue&type=script&lang=js"
export * from "./ActivityBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports